// extracted by mini-css-extract-plugin
export var bodySections = "_ae-8";
export var gray = "_ae-7";
export var green = "_ae-4";
export var iconContainer = "_ae-9";
export var iconWidgetContainer = "_ae-1";
export var phoneIcon = "_ae-2";
export var red = "_ae-5";
export var statusDot = "_ae-3";
export var widgetContainer = "_ae-0";
export var yellow = "_ae-6";